module.exports = __webpack_public_path__ + "img/stamp-refund.25b05fef.png";